/**
 * @fileoverview > handler for the "/engagement/campaigns" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { postCampaignCacheKeys } from "./constants";
import type { PostCampaignProps, PostCampaignDataResponse } from "./types";

export const postCampaign = reactQueryMutationAdapter(
  postCampaignCacheKeys,
  (props: PostCampaignProps): Promise<PostCampaignDataResponse> => {
    return fetch(`/engagement/campaigns`, "POST", props, {}, { propagateFetchRequestError: false });
  }
);
